import React, { useRef, useState } from 'react';
import { PASTOR_FIELDS, preparePastorRegistration } from '../utils/pastorRegistration';
import './PastorRegistration.css';

export default function PastorRegistration() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [receipt, setReceipt] = useState(null);
  const sending = useRef(false);

  async function submit(event) {
    event.preventDefault();
    if (sending.current || receipt) return;
    const data = new FormData(event.currentTarget);
    const input = { ...Object.fromEntries(data), consent: data.get('consent') === 'yes' };
    sending.current = true;
    setBusy(true);
    setError('');
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const { fields } = preparePastorRegistration(input);
      const response = await fetch('/api/jobs/pastor-registration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fields),
        signal: controller.signal,
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || (result.accepted !== true && result.delivered !== true)) {
        throw Error(result.message || '送信できませんでした。時間をおいて再度お試しください。');
      }
      setReceipt({ applicationId: result.applicationId });
    } catch (err) {
      setError(err.name === 'AbortError' ? '通信がタイムアウトしました。入力内容を残していますので、もう一度送信してください。' : err instanceof TypeError ? '通信に失敗しました。時間をおいて再度お試しください。' : err.message);
    } finally {
      clearTimeout(timer);
      sending.current = false;
      setBusy(false);
    }
  }

  return (
    <section className="pastor-registration" aria-labelledby="pastor-registration-title">
      <h2 id="pastor-registration-title">SOS対応牧師の登録</h2>
      <p>一般の方からのSOSに対応可能な牧師先生は、下記フォームから登録してください。</p>
      <p>登録内容を確認後、牧師一覧に掲載します。</p>
      {receipt ? (
        <div role="status" className="pastor-registration__receipt">
          <h3>登録申請を受け付けました</h3>
          <p>内容を確認後、運営からご連絡します。</p>
          {receipt.applicationId && <p>受付番号：{receipt.applicationId}</p>}
        </div>
      ) : (
        <form onSubmit={submit} aria-busy={busy}>
          <fieldset disabled={busy}>
            <legend>登録内容</legend>
            <div className="pastor-registration__fields">
              {PASTOR_FIELDS.map(field => (
                <label key={field.key} className={field.multiline ? 'pastor-registration__wide' : undefined}>
                  {field.label}（{field.required ? '必須' : '任意'}）
                  {field.multiline ? (
                    <textarea name={field.key} maxLength={field.maxLength} rows={3} />
                  ) : (
                    <input name={field.key} type={field.type || 'text'} required={field.required} maxLength={field.maxLength} placeholder={field.placeholder} autoComplete={field.autoComplete} />
                  )}
                </label>
              ))}
            </div>
            <label className="pastor-registration__consent">
              <input type="checkbox" name="consent" value="yes" required />
              <span>私は一般の方からのSOSに対応可能な牧師本人です。入力した名前・所属教会・信仰分類・対応地域・公開連絡先などの一覧掲載と、登録確認のための連絡に同意します。<a href="/privacy" target="_blank" rel="noreferrer">プライバシーポリシー</a>を確認しました。（必須）</span>
            </label>
            <button type="submit">{busy ? '送信中…' : 'この内容で登録を申請する'}</button>
          </fieldset>
          {error && <p role="alert">{error}</p>}
        </form>
      )}
    </section>
  );
}
